import type { AuthState } from "@/store/auth.store";
import { isLoginRecent } from "@/utils/isLoginRecent";
import { addDays, differenceInMilliseconds, startOfDay } from "date-fns";

const ONE_DAY_MS = differenceInMilliseconds(addDays(startOfDay(new Date()), 1), startOfDay(new Date()));

export const shouldRedirectToTop = (
  isFirstVisit: boolean,
  authState: AuthState,
  checkLoginRecent: () => boolean = isLoginRecent,
): boolean => {
  return !checkLoginRecent() && isFirstVisit && authState === "unauthenticated";
};

export const shouldDisplayLegalNotice = (
  lastLegalNoticeDisplayTime: number | null,
  now: number,
  limit = ONE_DAY_MS,
): boolean => {
  return !lastLegalNoticeDisplayTime || now - lastLegalNoticeDisplayTime >= limit;
};
